import { render, staticRenderFns } from "./SimilarListingsDistanceFilter.vue?vue&type=template&id=b96abee8&scoped=true&"
import script from "./SimilarListingsDistanceFilter.vue?vue&type=script&lang=js&"
export * from "./SimilarListingsDistanceFilter.vue?vue&type=script&lang=js&"
import style0 from "./SimilarListingsDistanceFilter.vue?vue&type=style&index=0&id=b96abee8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96abee8",
  null
  
)

export default component.exports